import type { QuoteDocument } from 'paintscout'
import { fixNumber } from '../util'

export function calculateBalanceDue(totals: QuoteDocument['totals']) {
  return fixNumber(totals.after_tax) - fixNumber(totals.amount_paid)
}
